export enum CommunicationType {
    OUTGOING = 1,
    INCOMING = 2,
}
